import { MenuConfigItem } from 'components/common/SideMenu/SideMenu';

type ProjectConfigKey =
    | 'statusSummary'
    | 'battlecards'
    | 'dataStories'
    | 'programLibrary'
    | 'versionCompare'
    | 'progressOverview'
    | 'crossVersionsAnalysis'
    | 'ganttChart'
    | 'scheduleViews'
    | 'risksDashboard'
    | 'HSSEDashboard'
    | 'changeLogDashboard'
    | 'qualityDashboard'
    | 'projectPreferences'
    | 'subProgramPreferences'
    | 'pinboards'
    | 'statusChanges'
    | 'startDateChanges'
    | 'finishDateChanges'
    | 'largestDurationVariance'
    | 'largestFloatChanges'
    | 'relationshipTypeChanges'
    | 'relationshipCountChanges'
    | 'largestAddedActivities'
    | 'criticalPathAdded'
    | 'criticalPathRemoved'
    | 'integratedProgramDetails'
    | 'myFocusPage'
    | 'productivity'
    | 'resourcesAnalysis'
    | 'editBulkActionRules'
    | 'completionPlan';

export const executionConfig: Record<ProjectConfigKey, MenuConfigItem> = {
    statusSummary: {
        name: 'Project Status',
        title: 'Project / Program Status',
        link: 'status-summary',
        tooltip: 'Project Status',
    },
    battlecards: {
        name: 'Project Activities',
        title: 'Project Activities',
        link: 'scope-To-Go',
        tooltip: 'Project Activities',
    },

    programLibrary: {
        name: 'Program Library',
        title: 'Program Library',
        link: 'library',
        tooltip: 'Program Library',
    },
    versionCompare: {
        name: 'Change Analysis',
        title: 'Change Analysis',
        link: 'version-compare',
        tooltip: 'Change Analysis',
    },
    progressOverview: {
        name: 'Progress',
        title: 'Progress',
        link: 'progress-overview',
        tooltip: 'Progress',
    },
    crossVersionsAnalysis: {
        name: 'Trends',
        title: 'Cross Versions Trends',
        link: 'trend-analysis',
        tooltip: 'Trends',
    },
    ganttChart: {
        name: 'Gantt',
        title: 'Gantt',
        link: 'gantt-chart',
        tooltip: 'Gantt',
    },
    scheduleViews: {
        name: 'Schedule Views',
        title: 'Schedule Views',
        link: 'schedule-views',
        tooltip: 'Schedule Views',
    },
    dataStories: {
        name: 'Data Stories',
        title: 'Project Data Stories',
        link: 'data-stories',
        tooltip: 'Data Stories',
    },

    risksDashboard: {
        name: 'Risks Dashboard',
        title: 'Risk Report',
        link: 'risks',
    },
    HSSEDashboard: {
        name: 'HSSE Dashboard',
        title: 'HSSE Report',
        link: 'hsse',
    },
    changeLogDashboard: {
        name: 'Change Log Dashboard',
        title: 'Change Log Report',
        link: 'log-report',
    },
    qualityDashboard: {
        name: 'Quality Dashboard',
        title: 'Quality Report',
        link: 'quality-report',
    },
    projectPreferences: {
        name: 'Project Preferences',
        title: 'Project Preferences',
        link: 'project-preferences',
    },
    subProgramPreferences: {
        name: 'Sub Program Preferences',
        title: 'Sub Program Preferences',
        link: 'sub-program-preferences',
    },

    statusChanges: {
        name: '',
        title: 'Top Status Changes',
        link: 'status-changes',
    },

    startDateChanges: {
        name: '',
        title: 'Top Start Date Changes',
        link: 'start-date-changes',
    },
    finishDateChanges: {
        name: '',
        title: 'Top Finish Date Changes',
        link: 'finish-date-changes',
    },
    criticalPathAdded: {
        name: '',
        title: 'Critical Path Added',
        link: 'critical-path-added',
    },
    criticalPathRemoved: {
        name: '',
        title: 'Critical Path Removed',
        link: 'critical-path-removed',
    },

    largestDurationVariance: {
        name: '',
        title: 'Largest Duration Variance',
        link: 'largest-duration-variance',
    },
    largestFloatChanges: {
        name: '',
        title: 'Largest Float Changes',
        link: 'largest-float-changes',
    },
    relationshipTypeChanges: {
        name: '',
        title: 'Top Relationships Type Changes',
        link: 'relationships-type-changes',
    },
    relationshipCountChanges: {
        name: '',
        title: 'Top Relationships Count Changes',
        link: 'relationships-count-changes',
    },
    largestAddedActivities: {
        name: '',
        title: 'Largest Added Activities',
        link: 'largest-added-activities',
    },
    pinboards: {
        name: 'Pinboards',
        title: 'Pinboards',
        link: 'custom-pinboard',
        tooltip: 'Pinboards',
    },
    integratedProgramDetails: {
        name: '',
        title: 'Version Details',
        link: 'version-details',
    },
    myFocusPage: {
        name: 'My Focus Page',
        link: 'my-focus-page',
        title: 'My Focus Page',
        tooltip: 'My Focus Page',
    },
    productivity: {
        name: 'Productivity',
        link: 'productivity',
        title: 'Productivity',
        tooltip: 'Productivity',
    },
    resourcesAnalysis: {
        name: 'Resources Analysis',
        link: 'resources-analysis',
        title: 'Resources Analysis',
        tooltip: 'Resources Analysis',
    },
    editBulkActionRules: {
        name: 'Edit Bulk Action Rules',
        title: 'Edit Bulk Action Rules',
        link: 'edit-bulk-action-rules',
    },
    completionPlan: {
        name: 'Completion Plan',
        title: 'Completion Plan',
        link: 'completion-plan',
        tooltip: 'Completion Plan',
    },
};
